/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import PropTypes from 'prop-types';

// Component imports
import ReactMarkdown from 'react-markdown';

const ReactMarkdownList = ({ message, icon }) => {
  return (<div className="mb-3">
    {icon}
    <ReactMarkdown
      className="mt-3 ml-2 d-inline-block markdown-list-inline"
      skipHtml
      components={{ p: 'span' }}
      linkTarget="_blank"
    >
      {message}
    </ReactMarkdown>
  </div>);
};

ReactMarkdownList.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.node
};

export default ReactMarkdownList;
